<template>
  <div class="vqb-rule card">
    <member
      :member="member"
      :vars="vars"
      :operator="operatorText"
    />
  </div>
</template>

<script>
import Member from '@/components/notifications/settings/Member';

export default {
  name: 'ExpressionRule',
  components: { Member },
  props: ['query', 'depth', 'index', 'vars', 'members'],
  computed: {
    member() {
      return this.members[this.query.rule];
    },
    operatorText() {
      if (this.query.operator === '=') {
        return this.$t('is');
      }
      return this.query.operator;
    },
  },
};
</script>

<style scoped>

</style>
